const myAccessRequests = {
  errors: {
    loadFailed: "Failed to load access requests",
  },
  status: {
    pendingEmailVerification: {
      badge: "Awaiting Email Verification",
      message:
        "Please verify your email address to complete your access request.",
    },
    pending: {
      badge: "Under Review",
      message: "Your request is under review by the Principal Investigator.",
    },
    approved: {
      badge: "Approved",
      message: "Your access request has been approved!",
    },
    rejected: {
      badge: "Rejected",
      message: "Your access request was not approved.",
    },
  },
  title: "Requests to join a project",
  subtitle: "The status of your requests to join a project",
  empty: {
    noRequests: "No access requests found",
    hint: "Register or request access to a project to get started",
  },
  request: {
    heading: "Access Request #{{id}}",
    projectInterest: "Project Interest:",
    submitted: "Submitted:",
  },
  approvedDetails: {
    heading: "Approved for Project",
    role: "Role:",
    approvedOn: "Approved on {{date}}",
    notes: "Notes:",
  },
  rejectedDetails: {
    heading: "Request Not Approved",
    reviewedOn: "Reviewed on {{date}}",
    reason: "Reason:",
  },
};

export default myAccessRequests;
